<template>
  <div id="order-item">
    <div class="oi-details">
      <span class="oi-folio">{{ folio }}</span>
      <span class="oi-status">{{ stepTitle(status).title ? stepTitle(status).title : stepTitle(status) }}</span>
      <span class="oi-date">
        <span><i class="el-icon-time" /></span>
        {{ statusDate }}
      </span>
    </div>
    <div v-if="isRatingAvailable" class="oi-details">
      <span class="oi-folio">{{ folio }}</span>
      <el-rate :disabled="true" />
      <span class="oi-date">
        <span><i class="el-icon-time" /></span>
        {{ statusDate }}
      </span>
    </div>
  </div>
</template>
<script>
// Utils
import { object } from '@/utils/status'
import { getDate } from '@/utils/functions'
import startsAnimation from '@/assets/animations/lottie/starts.json'

// Constants
import DRIVER_CONSTANTS from '@/constants/driverConstants'

export default {
  name: 'OrderItem',
  props: {
    folio: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    src: {
      type: String,
      default: () => '/img/logo.png'
    },
    size: {
      type: String,
      default: () => '50px'
    },
    driver: {
      type: Object,
      required: true
    },
    client: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      object,
      order: true,
      backgroundColor: 'transparent',
      borderRadius: '0%',
      animations: {
        starts: {
          options: {
            animationData: startsAnimation,
            autoplay: true,
            loop: true
          },
          width: 200,
          height: 50,
          animation: null
        }
      }
    }
  },
  computed: {
    statusDate: function() {
      return getDate(this.date)
    },
    driverName: function() {
      let name = this.driver ? this.driver.name : 'Tú repartidor'
      name = name.split(' ')[0]
      return `${name.substr(0, 1).toUpperCase()}${name.substr(1).toLowerCase()}`
    },
    clientName: function() {
      let name = this.client ? this.client : ''
      name = name.split(' ')[0]
      return `${name.substr(0, 1).toUpperCase()}${name.substr(1).toLowerCase()}, `
    },
    isRatingAvailable: function() {
      return DRIVER_CONSTANTS.IS_RATING_AVAILABLE
    }
  },
  methods: {
    isCompleted: function(status) {
      return status === this.object.COMPLETED
    },
    stepTitle: function(step) {
      let _step
      if (step === object.PENDING) {
        _step = this.$t(`steps.${step}.title`, { name: this.clientName })
      } else if ([object.ACCEPTED, object.SUPPLIED, object.TRANSIT].includes(step)) {
        _step = this.$t(`steps.${step}`, { name: this.driverName })
      } else if (step === object.ONSITE) {
        _step = this.$t(`steps.${step}.description`, { name: this.driverName })
      } else if ([object.COMPLETED, object.CANCELED].includes(step)) {
        _step = this.$t(`steps.${step}.description`)
      } else {
        _step = this.$t(`steps.${step}`)
      }
      return _step
    }
  }
}
</script>
